import { colors } from '@galapagos/design-system/colors';
import { sizing } from '@galapagos/design-system/sizing';
import { spacing } from '@galapagos/design-system/spacing';

export const LEGAL_DOCUMENT_STYLE_ID = 'signup-legal-document-style';

/**
 * Layout for the legal pages. The design system has no list or table
 * component, so lists and tables are plain elements styled here; the words in
 * them render through design-system `Text` and `Link`. Every value is a token.
 * Nothing has a fixed width: the column and its tables shrink to the screen,
 * and table cells wrap long words, so a four-column table fits a phone.
 * Cells hyphenate first (the document is tagged English), so a narrow column
 * breaks "infor-mation" rather than splitting it with no hyphen. The document
 * ends with room above the site footer so the two do not run together.
 */
export function legalDocumentCss(): string {
  return `
.signup-legal { display: flex; flex-direction: column; gap: ${spacing.m}px; padding-bottom: ${spacing.xxl}px; max-width: 100%; min-width: 0; overflow-wrap: anywhere; }
.signup-legal__heading { margin: ${spacing.s}px 0 0; }
.signup-legal__paragraph { margin: 0; }
.signup-legal__list { margin: 0; padding-left: ${spacing.lg}px; display: flex; flex-direction: column; gap: ${spacing.s}px; }
.signup-legal__table { width: 100%; max-width: 100%; border-collapse: collapse; }
.signup-legal__cell { border: ${sizing.stroke.hairline}px solid ${colors.stroke.primary}; padding: ${spacing.s}px; vertical-align: top; text-align: left; hyphens: auto; overflow-wrap: anywhere; }
.signup-legal__cell > * + * { margin-top: ${spacing.s}px; }
`;
}

/** Injects the legal page stylesheet once per document. No-op during prerender. */
export function ensureLegalDocumentStyle(): void {
  if (typeof document === 'undefined' || document.getElementById(LEGAL_DOCUMENT_STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = LEGAL_DOCUMENT_STYLE_ID;
  style.textContent = legalDocumentCss();
  document.head.appendChild(style);
}
